module.exports = __webpack_public_path__ + "static/media/redone.b43d62b3.png";